export enum CompensationType {
  SALARY_CHANGE = 'salary-change',
  ONE_TIME_VARIABLE_PAY = 'one-time-variable-pay',
  RECURRING_VARIABLE_PAY = 'recurring-variable-pay',
}
